var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImgInterviewNoApprove = function SvgImgInterviewNoApprove(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 210,
    viewBox: "0 0 174 210",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.461 42.8069V146.778L68.6863 90.4845L67.5771 0L173.461 42.8069Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.461 146.778L106.043 210L0.15918 167.193L68.6857 90.4846L173.461 146.778Z",
    fill: "#E5E5E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.843 203.201C139.768 155.499 160.078 105.555 173.46 53.2556L156.928 137.889L112.843 203.201Z",
    fill: "#909090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.843 203.2L6.95898 160.393C36.1748 115.384 56.2682 65.3436 67.5767 10.4485L173.461 53.2554C160.071 105.555 139.76 155.499 112.843 203.2Z",
    fill: "#BDBDBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.851 93.2493C109.083 97.9512 116.147 110.65 111.108 121.694C107.001 133.123 93.048 136.707 82.6075 132.938C71.4356 129.064 68.4135 115.995 72.3277 105.997C76.7322 96.408 87.9925 88.1939 98.851 93.2493ZM99.8717 89.2869C87.1164 83.9823 73.3565 92.2447 68.6787 104.518C62.8838 116.598 68.2206 131.306 80.7669 136.281C93.3695 141.899 109.484 136.056 114.765 123.172C119.949 110.289 113.037 94.1736 99.8717 89.2869Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.698 124.973C85.9505 124.667 85.4602 124.161 85.2111 123.438C84.9619 122.722 85.0262 121.975 85.3879 121.203C85.7496 120.432 86.3042 119.877 87.0356 119.556C87.775 119.234 88.5064 119.218 89.2539 119.523C89.9933 119.829 90.4997 120.343 90.7649 121.075C91.0301 121.806 90.9819 122.562 90.6202 123.341C90.2585 124.121 89.6959 124.659 88.9485 124.965C88.1929 125.278 87.4455 125.278 86.698 124.973ZM92.6376 105.675C93.1922 103.979 93.4654 103.119 93.9718 101.407C95.6677 102.09 96.5116 102.428 98.2075 103.103C97.5725 104.775 97.251 105.603 96.5759 107.258C94.7032 111.615 93.6905 113.761 91.5767 117.956C90.4836 117.514 89.929 117.289 88.8359 116.839C90.4756 112.459 91.2552 110.216 92.6376 105.675Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgInterviewNoApprove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "public/media/img_interview_no_approve.edc62f9d.svg";
export { ForwardRef as ReactComponent };